export default __webpack_public_path__ + "static/media/fullscreen_logo.1b136946.webp";